import { render, staticRenderFns } from "./sep-faqs.vue?vue&type=template&id=542f55f2&scoped=true&"
import script from "./sep-faqs.vue?vue&type=script&lang=js&"
export * from "./sep-faqs.vue?vue&type=script&lang=js&"
import style0 from "./sep-faqs.vue?vue&type=style&index=0&id=542f55f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f55f2",
  null
  
)

export default component.exports